import { TaskType } from '@/shared/domain/taskTypes';

export function countsMapToRows(counts) {
  if (!counts || typeof counts !== 'object') return [];
  return Object.entries(counts)
    .map(([name, v]) => {
      const obj = typeof v === 'object' && v !== null ? v : {};
      return { label: name, total: Number(obj.total) || 0, validated: Number(obj.validated) || 0 };
    })
    .filter((r) => r.total > 0)
    .sort((a, b) => b.total - a.total);
}

export function getBenchmarkSections(taskType, selectedRow) {
  const row = selectedRow || {};
  const isNer = taskType === TaskType.NER;
  const isNerWithRelations = taskType === TaskType.NER_WITH_RELATIONS;
  const isClassification = taskType === TaskType.classification;

  if (isNerWithRelations) {
    return [
      {
        title: 'Entity distribution and % reviewed',
        nameColumnHeader: 'Entity Name',
        rows: countsMapToRows(row.benchmark_entity_names_count),
      },
      {
        title: 'Relations distribution and % reviewed',
        nameColumnHeader: 'Relation Name',
        rows: countsMapToRows(row.benchmark_relation_names_count),
      },
    ];
  }
  if (isNer) {
    return [
      {
        title: 'Entity distribution and % reviewed',
        nameColumnHeader: 'Entity Name',
        rows: countsMapToRows(row.benchmark_entity_names_count),
      },
    ];
  }
  if (isClassification) {
    return [
      {
        title: 'Label distribution and % reviewed',
        nameColumnHeader: 'Label name',
        rows: countsMapToRows(row.benchmark_label_names_count),
      },
    ];
  }
  return [];
}

/** Empty prompt/schema values render as a hyphen, matching the Figma nested row. */
export function displayPromptOrSchema(value) {
  if (value == null || value === '') return '-';
  if (typeof value === 'object') {
    try {
      const text = JSON.stringify(value, null, 2);
      return text && text !== '{}' ? text : '-';
    } catch {
      return '-';
    }
  }
  const text = String(value);
  return text.trim() === '' ? '-' : text;
}

export function resolveStudentField(record, overrideKey, teacherKey) {
  const override = record?.[overrideKey];
  if (override != null) return displayPromptOrSchema(override);
  return displayPromptOrSchema(record?.[teacherKey]);
}
